import { authRequest } from './utils';

/**
 * deleteRequestLog :: ID -> Promise Error Object
 */
export const deleteRequestLog = requestLogId =>
  authRequest({
    method: 'DELETE',
    url: `/request-logs/${requestLogId}`,
  })
    .then(({ data }) => data);




// WEBPACK FOOTER //
// ./src/api/apiko-api/request-logs.js